(function () {
    var root = document.querySelector('[data-cn]');
    if (!root) return;
    var bar = root.querySelector('[data-cn-bar]');
    var drawer = root.querySelector('[data-cn-drawer]');
    var desktop = window.matchMedia('(min-width: 1180px)');

    /* ---- alturas para el resto del tema (barra sticky del 2x1, héroes, etc.) ---- */
    function measure() {
      var grp = document.getElementById('header-group');
      var g = 0;
      if (grp) {
        for (var i = 0; i < grp.children.length; i++) g += grp.children[i].offsetHeight;
      }
      document.body.style.setProperty('--header-height', bar.offsetHeight + 'px');
      document.body.style.setProperty('--header-group-height', g + 'px');
    }
    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      ro.observe(bar);
      var grp0 = document.getElementById('header-group');
      if (grp0) for (var k = 0; k < grp0.children.length; k++) ro.observe(grp0.children[k]);
    }

    /* ---- escritorio: mega menú ---- */
    var tops = [].slice.call(root.querySelectorAll('[data-cn-top]'));
    var timer;
    function setTop(li) {
      tops.forEach(function (l) {
        var on = l === li;
        l.classList.toggle('is-open', on);
        var b = l.querySelector(':scope > button');
        if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    root.querySelectorAll('.cn-top > li').forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(timer);
        setTop(li.hasAttribute('data-cn-top') ? li : null);
      });
      var b = li.querySelector(':scope > button');
      if (b) b.addEventListener('click', function () {
        var canHover = window.matchMedia('(hover: hover)').matches;
        setTop(!canHover && li.classList.contains('is-open') ? null : li);
      });
    });
    bar.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { setTop(null); }, 160);
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) setTop(null);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setTop(null); closeDrawer(); }
    });

    /* subcategorías dentro del mega menú */
    root.querySelectorAll('.cn-cat > button.cn-c').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.parentElement;
        var on = !c.classList.contains('is-open');
        c.classList.toggle('is-open', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });

    /* ---- móvil: cajón con acordeón ---- */
    var opener = root.querySelector('[data-cn-open]');
    function openDrawer() {
      drawer.classList.add('is-open');
      document.documentElement.classList.add('cn-lock');
      var x = drawer.querySelector('button[data-cn-close]');
      if (x) x.focus();
    }
    function closeDrawer() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('cn-lock');
      if (opener) opener.focus();
    }
    if (opener) opener.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-cn-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    var sb = drawer.querySelector('[data-cn-search]');
    if (sb) sb.addEventListener('click', function () {
      closeDrawer();
      var hb = root.querySelector('search-button button');
      if (hb) hb.click();
    });
    desktop.addEventListener('change', function () { if (desktop.matches) closeDrawer(); });

    drawer.querySelectorAll('button.cn-row').forEach(function (b) {
      b.addEventListener('click', function () {
        var li = b.parentElement;
        var on = !li.classList.contains('is-open');
        if (li.hasAttribute('data-cn-m1')) {
          drawer.querySelectorAll('li[data-cn-m1].is-open').forEach(function (x) {
            x.classList.remove('is-open');
            x.querySelector(':scope > .cn-row').setAttribute('aria-expanded', 'false');
          });
        }
        li.classList.toggle('is-open', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  })();
